<template lang="">
    <div class="session">
        <div class="content">
            <h1 class="mb-2">THÔNG BÁO</h1>
            <h5>Bạn đã không thao tác quá <span style="font-weight: 600">30 phút</span>. Hiện tại đã hết phiên làm việc. 
            Hãy bấm QUAY LẠI ĐĂNG NHẬP để tiếp tục!</h5>
        </div>
        
        <img class='img-sesstion' src="../../img/session.png"/>
        <el-button type="primary" class="btn-login" @click="fn_clickLogin()">QUAY LẠI ĐĂNG NHẬP</el-button>
    </div>
</template>
<script>
export default {
  methods: {
    fn_clickLogin() {
      let urlLogin = location.origin + "/auth/login";
      window.location.replace(urlLogin);
    },
  },
};
</script>
<style lang="scss" scope>
.session {
  position: relative;
  background-color: #fff;
  height: 100vh;
  display: flex;
  justify-content: center;
  .content,
  .btn-login {
    position: absolute;
  }
  .content {
    text-align: center;
    top: 60px;
  }
  .btn-login {
    bottom: 50px;
  }
}
.img-sesstion {
  height: 77%;
  margin-top: 135px;
  object-fit: cover;
}
</style>